import ChannelStatusIcon  from './ChatRoomStatusIcon';

export default ChannelStatusIcon;
